<!--
	描述：消息弹窗,自动消失
-->
<template>
	<transition name="nomal-fade">
		<div class="wedoToast" v-show="isShow" @click="msgList.shift()">
			<p class="title">系统通知</p>
			<p class="message">{{nowMsg}}</p>
		</div>
	</transition>
</template>

<script>
	export default {
		props: [],
		data() {
			return {
				msgList: [], //要显示的消息列表
				lastShowTime: 0, //上一条消息的时间
				minShowTime: 1500, //每条消息最少显示多久
				maxShowTime: 3000, //每条消息最多显示多久
				nowMsg: '', //当前显示的信息
			}
		},
		computed: {
			isShow() {
				return this.msgList.length > 0
			}
		},
		watch: {
			msgList(nv, ov) {
				if (nv.length > 0) {
					this.nowMsg = nv[0]
				}
			}
		},
		mounted() {
			addNewTask("showMessageDialog", 0, 100, -1, () => {
				if (this.msgList.length == 0) {
					return
				}
				//不断检查是不是需要显示弹窗
				var nowtime = new Date().getTime()
				if (this.lastShowTime == 0) {
					this.lastShowTime = nowtime
					return
				}
				//是否要切换或者隐藏
				var toggle = false
				if (nowtime - this.lastShowTime >= this.minShowTime && this.msgList.length > 1) {
					toggle = true
					this.lastShowTime = nowtime
				} else if (nowtime - this.lastShowTime >= this.maxShowTime) {
					toggle = true
					this.lastShowTime = 0
				}
				if (toggle) {
					//需要切换或者隐藏了
					this.msgList.shift()
				}
			})
		},
		methods: {
			showMessage(msg) {
				//忽略已存在的
				if (!this.msgList.includes(msg)) {
					this.msgList.push(msg)
				}
			}
		}
	}
</script>
<style scoped>
	.wedoToast {
		position: fixed;
		right: 0;
		left: 0;
		top: 2rem;
		width: 4rem;
		margin: auto;
		padding: 0;
		background: white;
		border: .01rem solid gray;
		border-radius: .06rem;
		color: black;
		z-index: 1000;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	.title {
		font-size: .14rem;
		font-weight: bold;
		text-align: left;
		line-height: .2rem;
		height: .2rem;
		padding: .1rem;
		border-bottom: .01rem solid gray;
		color: black;
		margin: 0;
	}

	.message {
		padding: .1rem;
		text-align: left;
		color: black;
		font-size: .16rem;
		line-height: .3rem;
		white-space: normal;
		word-break: break-all;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
